import React from 'react';
import { FaBrain, FaChalkboardTeacher, FaUsers } from 'react-icons/fa';

const WhyChooseUs = () => {
    const reasons = [
        {
            icon: <FaBrain className="w-10 h-10 text-primary" />,
            title: "Personalized Learning Paths",
            description: "AI creates customized courses for every learner"
        },
        {
            icon: <FaChalkboardTeacher className="w-10 h-10 text-primary" />,
            title: "Interactive Virtual Teachers",
            description: "Experience AI teachers that adapt to your learning style"
        },
        {
            icon: <FaUsers className="w-10 h-10 text-primary" />,
            title: "Collaborative Social Learning",
            description: "Learn together with AI peers for a social classroom experience"
        }
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Why Choose <span className="text-primary">Nexgen Learning</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Experience a revolutionary approach to education that combines cutting-edge technology with personalized learning
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {reasons.map((reason, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1 text-center"
                        >
                            <div className="flex justify-center mb-6">
                                {reason.icon}
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">{reason.title}</h3>
                            <p className="text-gray-600">{reason.description}</p>
                        </div>
                    ))}
                </div>
                <div className="mt-16 text-center">
                    <button className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-full hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
                        Start Your Free Trial
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;